import React from 'react';
import { useLang } from '../context/LanguageContext';
import { t } from '../data/translations';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const { lang } = useLang();

  const scrollToContact = () => {
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" data-testid="hero-section" className="relative min-h-screen flex items-center bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 w-full py-32 md:py-0">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left - Text */}
          <div className="animate-fade-in-up">
            <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-[#2563EB] font-['Manrope'] mb-6">
              {t.hero.overline[lang]}
            </span>
            <h1
              data-testid="hero-title"
              className="font-['Outfit'] text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-[#0F172A] leading-[1.05] mb-6"
            >
              {t.hero.title[lang]}
            </h1>
            <p className="font-['Manrope'] text-base md:text-lg text-[#475569] leading-relaxed max-w-lg mb-10">
              {t.hero.subtitle[lang]}
            </p>
            <Button
              data-testid="hero-cta-btn"
              onClick={scrollToContact}
              className="bg-[#0F172A] text-white hover:bg-[#2563EB] rounded-none font-['Manrope'] text-sm font-semibold px-8 h-12 transition-colors duration-200 group"
            >
              {t.hero.cta[lang]}
              <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" strokeWidth={1.5} />
            </Button>
          </div>

          {/* Right - Image */}
          <div className="animate-fade-in relative" style={{ animationDelay: '0.2s' }}>
            <div className="aspect-[4/3] overflow-hidden bg-[#F8FAFC]">
              <img
                src="https://images.unsplash.com/photo-1652211955967-99c892925469?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwZm9vZCUyMHByb2R1Y3Rpb24lMjB3YXJlaG91c2UlMjB3b3JrZXJzJTIwc2FmZXR5fGVufDB8fHx8MTc3NjE3MTM1Nnww&ixlib=rb-4.1.0&q=85"
                alt="Food production factory line"
                className="w-full h-full object-cover"
                loading="eager"
              />
            </div>
            {/* Decorative accent */}
            <div className="absolute -bottom-4 -left-4 w-24 h-24 border-2 border-[#2563EB] hidden lg:block" />
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center gap-2">
        <div className="w-px h-12 bg-[#E2E8F0]" />
      </div>
    </section>
  );
};

export default HeroSection;
